import { Emoticon, del_emoticon, emoticon_insert, qry_emoticons } from "../db/t_emoticon";
import time from "../time";
import Context from "./context";

export default class EmoticonController {
    public static async GetEmoticon(ctx: Context, skip: number, pageSize: number):
        Promise<{ error?: any, emoticons?: Emoticon[] }> {
        const r = await qry_emoticons(ctx.db, skip, pageSize)
        if (r.emoticons && r.emoticons.length > 0) {
            return r
        }
        return await this.GetRemote(ctx, skip, pageSize)
    }

    private static async GetRemote(ctx: Context, skip: number, pageSize: number): Promise<{ error?: any, total?: number, emoticons?: Emoticon[] }> {
        const r0 = await ctx.conn.Call("/v1/sdk/emoticon/list", { skip: skip, limit: pageSize });
        if (r0.code === 0) {
            if (r0.data && r0.data.emoticons && r0.data.emoticons.length > 0) {
                const emoticons = r0.data.emoticons as Emoticon[]
                const total = r0.data.total
                const r1 = await emoticon_insert(ctx.db, emoticons)
                return { total: total, emoticons: emoticons }
            } else {
                return { error: null }
            }
        } else {
            return { error: r0.msg }
        }
    }
    public static async DelEmoticon(ctx: Context, ids: string[]): Promise<{ error?: any }> {
        const r = await ctx.conn.Call("/v1/sdk/emoticon/delete", { ids: ids });
        if (r.code === 0) {
            await del_emoticon(ctx.db, ids)
            return { error: null }
        } else {
            return { error: r.msg }
        }
    }

    public static async AddEmoticon(ctx: Context, url: string): Promise<{ error?: any, emoticon?: Emoticon }> {
        const r = await ctx.conn.Call("/v1/sdk/emoticon/add", { url: url });
        if (r.code === 0) {
            const unixTime = time.toUnixMillSecond(time.now());
            const emoticon = { id: r.data.id, url: url, ctime: unixTime }
            await emoticon_insert(ctx.db, [emoticon])
            return { emoticon: emoticon }
        } else {
            return { error: r.msg }
        }
    }
}